<template>
  <transition name="dialog-fade">
    <div class="model__wrapper" v-show="visible">
      <div class="model" :style="{ width: width, marginTop: top }">
        <div class="model__header">
          <slot name="title">
            <span class="model-dialog__title">{{ title }}</span>
          </slot>
          <div class="close" @click="handleClose">
            <i class="iconfont icon-close"></i>
          </div>
        </div>
        <div class="model__body">
          <div class="model-content">
            <slot>
              <span>默认的内容</span>
            </slot>
          </div>
        </div>
        <div class="dialog__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "dialog",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    width: {
      type: String,
      default: "50%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    top: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      // 点遮罩让dialog消失方案一是通过$emit方法去传参触发父组件的事件让其隐藏
      // 方案二是通过this.$parent.visible去控制父组件的布尔值的改变
      this.$emit("close", false);
      // 瓤子租金的visible变成false
      // this.$parent.visible = false
      // this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss">
.model__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
  .model {
    position: relative;
    margin: 15vh auto 50px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    @include wh(500px, 600px);
    // padding: 30px 40px;
    .close {
      @include wh(33px, 33px);
      line-height: 33px;
      text-align: center;
      position: absolute;
      top: -18px;
      right: -44px;
      cursor: pointer;
      .iconfont {
        font-size: 33px;
        color: #fff;
        font-weight: 600;
      }
    }
    .model__header {
      @include wh(100%, 68px);
      text-align: center;
      line-height: 68px;
      background: #7966ff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px 4px 0px 0px;
      color: #fff;
      font-size: 26px;
    }
    .model__body {
      input {
        box-sizing: border-box;
        height: 42px;
        border: none;
        padding-left: 10px;
        font-size: 16px;
        border-radius: 4px;
        outline: none;
      }
      .model-content {
        p {
          margin-bottom: 30px;
        }
      }
      .login-modal-button {
        display: block;
        @include wh(420px, 42px);
        line-height: 42px;
        background: #7966ff;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
}
</style>
